import { render, staticRenderFns } from "./InvoiceTableGGTCopy.vue?vue&type=template&id=87539bf2&scoped=true"
import script from "./InvoiceTableGGTCopy.vue?vue&type=script&lang=js"
export * from "./InvoiceTableGGTCopy.vue?vue&type=script&lang=js"
import style0 from "./InvoiceTableGGTCopy.vue?vue&type=style&index=0&id=87539bf2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87539bf2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87539bf2')) {
      api.createRecord('87539bf2', component.options)
    } else {
      api.reload('87539bf2', component.options)
    }
    module.hot.accept("./InvoiceTableGGTCopy.vue?vue&type=template&id=87539bf2&scoped=true", function () {
      api.rerender('87539bf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/table/InvoiceTableGGTCopy.vue"
export default component.exports